import React from 'react'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { useOnInputChange } from '../../hooks/useOnInputChange'
// import { confirmSignUp } from '../../services/auth'
import Typography from '../../components/typography'
import TextField from '../../components/textfield'
import Button from '../../components/button'
import Box from '../../components/box'
import AuthPageLayout from '../../layout/auth_page_layout'
import { AuthService } from '../../apilibrary'
import { trackUserSignUpConfirmed, trackUserSignUpFailed } from '../../utils/analytics';

const SignupConfirmationPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const [confirmationCode, onChangeConfirmationCode] = useOnInputChange('')
  const [error, setError] = React.useState<string>()
  const [disableResendButton, setDisableResendButton] = React.useState(false)
  const [resentConfirmationCodeDone, setResentConfirmationCodeDone] = React.useState(false)
  const [disableButton, setDisableButton] = React.useState(false)
  const navigate = useNavigate()

  const email = searchParams.get('email')
  if (email == null) {
    return <Navigate to={'/404'} />
  }

  const handleConfirmUser = async (): Promise<void> => {
    try {
      setDisableButton(true)
      setError(undefined)
      await AuthService.confirmSignUp(email, confirmationCode)
      await trackUserSignUpConfirmed()
      navigate('/auth/login?email=' + email)
    } catch (e) {
      if (e instanceof Error) {
        setError(e.message)
      } else {
        setError('Something went wrong')
      }
      await trackUserSignUpFailed()
    } finally {
      setDisableButton(false)
    }
  }

  const handleResendConfirmationCode = async (): Promise<void> => {
    try {
      setDisableResendButton(true)
      setError(undefined)
      await AuthService.resendConfirmationCode(email)
      setResentConfirmationCodeDone(true)
    } catch (e) {
      if (e instanceof Error) {
        setError(e.message)
      } else {
        setError('Something went wrong')
      }
      setDisableResendButton(true)
    }
  }

  return (
    <AuthPageLayout title={'Signup Confirmation'}>
      <Typography textAlign={'center'}>Please Check your Email for confirmation</Typography>
      {(Boolean(error)) && <Typography color={'error'}>{error}</Typography>}
      <TextField
        disabled
        fullWidth
        gutterBottom
        label="Email"
        value={email}
      />
      <TextField
        fullWidth
        label="Confirmation Code"
        gutterBottom
        value={confirmationCode}
        onChange={onChangeConfirmationCode}
      />
      <Button disabled={disableResendButton || resentConfirmationCodeDone} onClick={handleResendConfirmationCode} variant='text'>{
        (resentConfirmationCodeDone) ? 'Confirmation Sent' : 'Resend Code'
      }</Button>
      <Box display={'flex'} justifyContent={'center'} my={'2rem'}>
        <Button disabled={disableButton} onClick={handleConfirmUser} variant='contained'>Confirm</Button>
      </Box>
    </AuthPageLayout>
  )
}

export default SignupConfirmationPage
